import React, { useEffect, useState } from 'react';
import Wrapper from './Wrapper';
import {
  getCurrentPage,
  requestsSelector,
  setCurrentRequestFilesSize,
  setNextButtonEnabled,
  setNextButtonHovered,
  setRequestData,
} from '../../../redux/slicers/requestSlicer';
import { useSelector, useDispatch } from 'react-redux';
import Tips from '../../../components/Request/Tips';
import styles from './Size.module.scss';
import UploadFile from '../../../components/Request/UploadFile';
import UploadedFiles from '../../../components/Request/UploadedFiles';
import cx from 'classnames';
import Dimensions from '../../../components/Request/Dimensions';
import { getFileFormData, setDefaultFiles, uploadRequestFile } from './helper';
import { apiDeleteRequestFile } from '../../../helpers/api';
import UploadFileWrapper from '../../../components/Request/UploadFileWrapper';
import DimensionTipImage from '../../../assets/images/requests/Dimension.png';
import { REQUEST_SUPPORTED_FILE_FORMATS } from '../../../constants/constants';

function Size({ className, isReadOnly }) {
  const _requestSelector = useSelector(requestsSelector);
  const dispatch = useDispatch();

  const TIP_TEXT =
    'Providing precise dimensions for the entire product and specific parts like arms, seat, and legs would be really helpful. You can even mark these dimensions on your product image and upload it here. \n\nThis will ensure accuracy in our work.'
  const [files, setFiles] = useState([]);
  const [dimension, setDimension] = useState([]);

  const handleFileChange = (_files) => {
    setFiles([...files, ..._files]);
    const formData = getFileFormData(_files, _requestSelector.currentRequestId, 'dimensionsImages');

    uploadRequestFile(formData, _files, files, setFiles, null, false, dispatch, _requestSelector);
  };

  const handleDeleteClick = async (_id) => {
    const _file = files.find((item) => item.id === _id)
    dispatch(setCurrentRequestFilesSize(_requestSelector.currentRequestFilesSize - _file.file.size));
    const _files = files.filter((item) => item.id != _id);
    setFiles(_files);

    await apiDeleteRequestFile(_id);
  };

  useEffect(async () => {
    if(_requestSelector.nextButtonHovered) dispatch(setNextButtonHovered(false))
    if(_requestSelector.currentRequestId) {
      setDefaultFiles(_requestSelector.currentRequestId, 'dimensionsImages', setFiles);
      const _dimensions = await setDefaultFiles(_requestSelector.currentRequestId, 'dimensions');
      let _dim = [];

      _dimensions?.results?.map((_item) => {
        _item.dimensions.map((i) => _dim.push({ ...i, actual_id: _item.id }));
      });

      setDimension(_dim);
    }
    
    if (!isReadOnly) dispatch(setRequestData(''));
  }, []);


  return (
    <Wrapper
      title={!isReadOnly && `Let’s get the sizing of ${_requestSelector.requestName}`}
      className={className}
      isReadOnly={isReadOnly}>
      <div className={cx('d-flex gap-5', styles.mainWrapper)}>
        <div className={cx(styles.uploadFileWrapper, isReadOnly && styles.fullWidth)}>
          <Dimensions defaultData={dimension} isReadOnly={isReadOnly} files={files} />
          <div
            className={cx(
              'p-3 bg-white mb-5',
              isReadOnly && !files.length && 'd-flex align-items-center'
            )}>
            <h6>
              {isReadOnly && !files.length && (
                <>
                  <span style={{ color: 'var(--primary-color)' }}>No </span> -{' '}
                </>
              )}
              Other files (pdf, xlsx, jpg, etc.)
            </h6>
            <div
              className={cx('d-grid gap-3 mb-4', styles.uploadedFilesWrapper)}
              style={
                files.length > 0
                  ? {
                      gridTemplateColumns: 'repeat(auto-fill, minmax(215px, 1fr))',
                    }
                  : {}
              }>
              {!isReadOnly && (
                <UploadFileWrapper fullWidth={!files.length}>
                  <UploadFile
                    className={
                      !files?.length
                        ? cx(styles.fullWidth, styles.heightFourHundread)
                        : 'w-100 h-100'
                    }
                    subClassName={'h-100'}
                    title="Drop and Down here"
                    subtitle="or"
                    allowed_files={REQUEST_SUPPORTED_FILE_FORMATS}
                    onFileChange={handleFileChange}
                    acceptMutipleFiles={true}
                  />
                </UploadFileWrapper>
              )}
              {files.map(
                (item, index) =>
                  item.file && (
                    <UploadedFiles
                      key={index}
                      _file={item}
                      onDeleteClick={() => handleDeleteClick(item.id)}
                      isReadOnly={isReadOnly}
                      variant={2}
                    />
                  )
              )}
            </div>
          </div>
        </div>
        {!isReadOnly && (
          <Tips
            title="3d file"
            text={TIP_TEXT}
            marginTop={2}
            showImages={false}
            customImages={[DimensionTipImage]}
          />
        )}
      </div>
    </Wrapper>
  );
}

export default Size;
